import { MetricEnum } from "~/types/metrics";
import { formatNumber, formatValue } from "~/utils/formatValue";

type MetricFormatter = (value: number | string | null | undefined) => string;

export const labelByMetricsKey: Partial<Record<MetricEnum, string>> = {
  [MetricEnum.TotalVolume]: "TOTAL VOLUME",
  [MetricEnum.Volume24h]: "24H VOL",
  [MetricEnum.Transactions24h]: "24H TRANSACTIONS",
  [MetricEnum.TotalOpenInterest]: "OPEN INTEREST",
  [MetricEnum.TotalActiveEvents]: "TOTAL EVENTS",
  [MetricEnum.MatchedEventGroups]: "MATCHED EVENTS",
  [MetricEnum.PlatformEventShare]: "PLATFORM COVERAGE",
};

export const formatterByMetricsKey: Partial<
  Record<MetricEnum, MetricFormatter>
> = {
  [MetricEnum.TotalVolume]: formatValue,
  [MetricEnum.Volume24h]: formatNumber,
  [MetricEnum.TotalOpenInterest]: formatNumber,
  [MetricEnum.TotalActiveEvents]: (value) =>
    formatNumber(value, { withDollar: false }),
  [MetricEnum.MatchedEventGroups]: (value) =>
    formatNumber(value, { withDollar: false }),
};

export const globalMetricsLineOrder: MetricEnum[] = [
  MetricEnum.TotalVolume,
  MetricEnum.Volume24h,
  MetricEnum.Transactions24h,
  MetricEnum.TotalOpenInterest,
  MetricEnum.TotalActiveEvents,
  MetricEnum.MatchedEventGroups,
  MetricEnum.PlatformEventShare,
  MetricEnum.KalshiPolymarketVolumeStats,
];
